import * as storage from '@/utils/storage'

// initial state
const state = {
  darkTheme: storage.theme.get() || false
}
// getters
const getters = {
  darkTheme: state => state.darkTheme,
}

// actions
const actions = {
  changeTheme({ commit }, data) {
    storage.theme.set(data)
    commit("setTheme", data)
  },
}

// mutations
const mutations = {
  setTheme(state, data) {
    state.darkTheme = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
